import React, { useMemo } from 'react';
import CustomModal from '../CustomModal/CustomModal';
import DataTable from '../DataTable';
import moment from 'moment';
import { iconArray } from '../../pages/ExamReport/iconArray';

const CenterWiseIncidentModal = ({
  showIncidentDetailsModal,
  setShowIncidentDetailsModal,
  rrb_name,
  incidents,
}) => {
  const incidentsCount = incidents.length;

  const getIconById = (id) => {
    const iconObj = iconArray.find((item) => item.id === id);
    return iconObj ? iconObj.icon : null;
  };

  const columns = useMemo(() => [
    {
      Header: 'Exam',
      accessor: 'exam',
      disableSortBy: true,
    },
    {
      Header: 'Date/Time',
      accessor: 'incident_timestamp',
      Cell: ({ value }) => {
        return moment(value).format('DD/MM/YYYY HH:mm');
      },
      disableSortBy: true,
    },
    {
      Header: 'Question',
      accessor: 'question',
      disableSortBy: true,
      Cell: ({ row }) => {
        const matchedIcon =
          iconArray.find(
            (iconObj) => iconObj.id === row.original.question_id
          ) || null;
        return (
          <span className='flex items-center gap-2'>
            {' '}
            {matchedIcon
              ? matchedIcon.icon
              : row.original.header.id
              ? getIconById(row.original.header.id)
              : getIconById(row.original.question_id)}
            &nbsp;
            {matchedIcon ? (
              row.original.question
            ) : (
              <>
                {row.original.header.subcat} <br /> <br />-{' '}
                {row.original.question}
              </>
            )}
          </span>
        );
      },
    },
    {
      Header: 'Incident',
      accessor: 'value',
      disableSortBy: true,
      Cell: ({ value }) => {
        return <span className='text-danger '>{value}</span>;
      },
    },
  ]);

  return (
    <div>
      <CustomModal
        show={showIncidentDetailsModal}
        onHide={setShowIncidentDetailsModal}
        hasSave={false}
        hasActions={false}
        size='lg'
        centered
        modalHeading={`${incidents[0].rrb_name} (${incidents[0].rrb_city}) | ${incidents[0].center_code} | ${incidents?.[0].center_name} Incidents`}
        hadBodyPadding
        scrollable
      >
        <DataTable
          cardClass='border-0 shadow-none'
          columns={columns}
          data={incidents.length > 0 ? incidents : []}
          totalRecords={incidentsCount}
          tableHooks={() => {}}
          defaultPageLength={[25, 50, 100]}
          manual={true}
          align='table-vcenter'
          hidePagination
          hideSearch
        />
      </CustomModal>
    </div>
  );
};

export default CenterWiseIncidentModal;
